var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.328 14.828a4.002 4.002 0 0 1-6.147-.592l-1.658 1.119a6.1 6.1 0 0 0 1.621 1.62c.65.44 1.38.746 2.148.903a6 6 0 0 0 2.415 0 5.97 5.97 0 0 0 3.034-1.634c.272-.271.52-.571.734-.889l-1.658-1.119q-.215.319-.489.592M9 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.993-.014a1.493 1.493 0 1 0 0-2.986 1.493 1.493 0 0 0 0 2.986"
  })));
};
export default SvgSmile;